import { useEffect, useRef, useState } from "react";

export function useLoadingTimeout(
  loading: boolean,
  timeoutMs: number,
): boolean {
  const [timedOut, setTimedOut] = useState(false);
  const handleRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    if (!loading) {
      if (handleRef.current) {
        clearTimeout(handleRef.current);
        handleRef.current = null;
      }
      setTimedOut(false);
      return;
    }
    if (handleRef.current) return;
    handleRef.current = setTimeout(() => {
      setTimedOut(true);
    }, timeoutMs);
    return () => {
      if (handleRef.current) {
        clearTimeout(handleRef.current);
        handleRef.current = null;
      }
    };
  }, [loading, timeoutMs]);

  return timedOut;
}
